
import { cn } from "@/lib/utils";

interface TimelineLineProps {
  variant: "solid" | "dotted";
  className?: string;
}

const TimelineLine = ({ variant, className }: TimelineLineProps) => {
  return (
    <div 
      className={cn(
        "absolute top-0 bottom-0 left-1/2 w-0.5 -translate-x-1/2 z-0",
        variant === "solid" 
          ? "bg-uplivion-blue bg-opacity-20" 
          : "bg-none",
        className
      )}
      style={
        variant === "dotted" 
          ? { background: "repeating-linear-gradient(180deg, #3b83f63b 0, #3b83f63b 8px, #0000 0, #0000 16px)" } 
          : {}
      }
    />
  );
};

export default TimelineLine;
